import SglContext from "../SglContext";
import {Link, useSearchParams, useNavigate} from 'react-router-dom'
import bullet_red from '../images/bullet_red.png'
import bullet_yellow from '../images/bullet_yellow.png'

import bullet_green from '../images/bullet_green.png'
import axios from "axios"
import './classSignups.css'
const { useState, useEffect, useContext, useRef } = require("react");
var interval;


function ClassSignup(props){
const [rings, set_rings] = useState([])
const [show, setShow] = useState({})
const [current_show, setCurrent_show] = useState(localStorage.getItem('show_id'))
const [expanded_status, setExpanded_status] = useState(localStorage.getItem("ring_exp_status")? JSON.parse(localStorage.getItem("ring_exp_status")): {})
const [show_days_list, setShow_days_list] = useState([])
const [show_date, setShow_date] = useState('00/00/00')
const [show_name, setShow_name] = useState('')
const [display_date, setDisplay_date] = useState('')
const [show_est_time, setShow_est_time] = useState(false)
const [show_planned_time, setShow_planned_time] = useState(false)
const [loading, setLoading] = useState(true)
const [TimeOutCounter, setTimeOutCounter] = useState(0)
const [TimeOutInterval, setTimeOutInterval] = useState(0)
const [userData, setUserData] = useState({})
const Sgl = useContext(SglContext)
const navigate = useNavigate();
const latestRequestRef = useRef(0);


//API END POINTS
const sgl_webservice_class_signups = Sgl.nestApiUrl+'/classsignup';
const user_info_url = Sgl.nestApiUrl+'/users/getUser';

      useEffect(() => {

        if(TimeOutInterval) {
          clearInterval(TimeOutInterval);
        }
        let current_date = show_date
        let Interval = setInterval(() => {
          setTimeOutCounter(prevTimeOutCounter => prevTimeOutCounter + 1);
        }, 60000);  
        setTimeOutInterval(Interval);
        if(props.current_show != current_show && props.current_show != 0 && current_show != 0 && !loading) {
          setShow_date('')
          appendDateToURL('')
          current_date = ''
        }
        if (loading) {
          current_date = getQueryVariable("date") ? getQueryVariable("date"): "00/00/00"
          setShow_date(current_date);
        }
      getClassSignupData(current_date, props.current_show);
      }, [props.current_show, show_date,TimeOutCounter, Sgl.currentTeamId]);
    

    function getQueryVariable(variable)
    {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
         }
         return(false);
    }

    function getClassSignupData(show_date, show){
        const requestId = ++latestRequestRef.current;
        document.title = "Class Signups";

        axios.get(sgl_webservice_class_signups,{
          params : {
              show_date : show_date,
              show_id : show,
              customer_id: Sgl.company_id,
              team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
          }
        }).then(results => {
          if (requestId === latestRequestRef.current) {
            Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+show+'/classsignup/list/'+show_date);
            Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+show+'/classsignup/list/'+show_date);
            setShow(results.data.show)
            set_rings( results.data.rings?results.data.rings:[])
            setCurrent_show( results.data.show_id)
            setShow_name( results.data.show.show_name)
            setShow_days_list( results.data.show_days_list)
            setShow_date(results.data.show_date)
            setDisplay_date(results.data.display_date)
            setShow_est_time (results.data.show_est_time)
            setShow_planned_time (results.data.show_planned_time)
          }
          setLoading (false)
      })
      
      
    }
    
    function setRingExpStatus(){
      var ring_statuses = JSON.parse(localStorage.getItem('ring_exp_status'));
      var ring_status_list = {};
      if(ring_statuses == null || ring_statuses == {}){
        if (rings.length > 0){
          for(var i=0; i< rings.length; i++){
            var ring_number = rings[i]['ring_number'];
            ring_status_list[ring_number] = "1";
          }
          localStorage.setItem('ring_exp_status', JSON.stringify(ring_status_list));
        }
      }
    }

    function onChangePage(page) {
      getClassSignupData(show_date, current_show);
    }

    function onShowChange(show_id) {
      localStorage.setItem('show_id', show_id);
      // remove local storage values for rings order and expand status
      localStorage.removeItem("ring_exp_status");

      getClassSignupData('00/00/00', show_id);
    }

    const appendDateToURL = (date) => {
      var url = window.location.href, newurl;
      if(url.search('&date=') > 0){
        newurl = url.replace(/&date=(.*)/, '&date=' + date);
      } else if(url.indexOf("?date=") > 0){
        newurl = url.replace(/[?]date=(.*)/, '?date=' + date);
      } else{
        newurl = url + (url.indexOf('?') > 0 ? '&' : '?') + 'date=' + date;
      }
      window.history.pushState(date, '', newurl);
    }

    const openTab = (tabName) => (e) => {
      appendDateToURL(tabName)
      setShow_date(tabName)
      var i, tablinks;

      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      e.currentTarget.className += " active";
      getClassSignupData(e.currentTarget.id, current_show);
    }
    function format_time(timeString){
      if(timeString){
        var H = +timeString.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? " AM" : " PM";
        timeString = h + timeString.substr(2, 3) + ampm;
        return timeString;
      }
      return;
    }

    function format_date_without_year(unformatted_date){
      var unformatted_date_split = (unformatted_date && unformatted_date.split)?unformatted_date.split('T')[0]:unformatted_date;
      var formatted_date = (new Date(unformatted_date_split));
      formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
      return parseInt(formatted_date.getMonth()+1) +"/"+ formatted_date.getDate();
    }

    const setArrow = (ring_number) => {
      var ring_statuses = JSON.parse(localStorage.getItem('ring_exp_status'));

      let className = 'direction';
      var status = ring_statuses[ring_number];

      className += (status === "1") ? ' asc' : ' desc';
      return className;
    };

    const getExtendedClass = (ring_number) => {
      var ring_statuses = JSON.parse(localStorage.getItem('ring_exp_status'));

      var status = ring_statuses[ring_number];

      return (status === "1") ? 'expanded' : 'unexpanded';
    };

    const getHeaderExtendedClass = (ring_number) => {
      var ring_statuses = JSON.parse(localStorage.getItem('ring_exp_status'));

      var status = ring_statuses[ring_number];

      return (status === "0") ? 'expanded' : 'unexpanded';
    };

    const handleExpandClick = (ring_number) => (e) => {
      var ring_statuses = JSON.parse(localStorage.getItem('ring_exp_status'));
      var status = ring_statuses[ring_number];
      status = status === "1"?"0":"1";
      ring_statuses[ring_number] = status;
      localStorage.setItem('ring_exp_status', JSON.stringify(ring_statuses));

      if(status === "0"){
        document.getElementById('detail'+ring_number).style.display = "none";

      } else {
        document.getElementById('detail'+ring_number).style.display = "block";

      }

      let className = 'direction';
      className += status === "1" ? ' asc' : ' desc';
      e.currentTarget.className = className;

    }

    function getClassIds(classes){
      const array = [];

      for(var i=0; i<classes.length;i++){
        array.push(<Link to={'/classes/detail?cid='+classes[i]['class_id']+'&sid='+current_show}>
            &nbsp;{classes[i]['class_number']}
          </Link>);
      }
      return array;
    }
    const openClass = (classes) => (event) => {
      if(event.target.tagName == 'A'){
        return;
      }
      if(classes.length > 0){
        navigate('/classes/detail?cid='+classes[0].class_id+'&sid='+current_show);
      }
    }

    function getBullets(upcoming_class){
      if(upcoming_class['signup_publish']==false){
        return <img src={bullet_red} className="bullet-icon" />
      }
      else if(upcoming_class['not_started']){
        return <img src={bullet_yellow} className="bullet-icon" />
      }else if(upcoming_class['ended']){
        return <img src={bullet_red} className="bullet-icon" />
      }else{
        return <img src={bullet_green} className="bullet-icon" />
      }
    }

    function getView(upcoming_class){
        if(upcoming_class.schedule_break){
          // do nothing
        }
        else if(upcoming_class.all_orders_set){
            return <div><Link to={'/classsignup/viewSetOrder?cgid='+upcoming_class.class_group_id+'&sid='+current_show}>
                View Set Order
            </Link></div>
        }
        else if(upcoming_class.model_class){
            return <div>Class is Model</div>
        }
        else if(upcoming_class.under_saddle_class){
            return <div>Class is Under Saddle</div>
        }
        else if(upcoming_class['check_in']==true){
            return <div>Check-In at Ingate</div>
        }
        else if(upcoming_class['signup_publish']==false){
            return <div>Order Not Yet Set</div>

        }
        else if(upcoming_class['not_started']){
        //     if($sf_user->hasCredential("show_admin") && in_array($CustomerID, sfOutputEscaper::unescape($sf_user->getAttribute("show_admin_company_id")))){
                  // return <td>
                  //     Opens at {format_date_without_year(upcoming_class.start_classsignup_date)} {format_time(upcoming_class.start_classsignup_time)}
                  //     <br/><a href={site_url+'classsignup/index?cgid='+upcoming_class['class_group_id']}>Admin Change</a>
                  //   </td>
        //     }else{
                  return <div>Opens at {format_date_without_year(upcoming_class.start_classsignup_date)} {format_time(upcoming_class.start_classsignup_time)}</div>

        //     }
        }
        else if(upcoming_class['ended']){
            
        //     /*SHOW YOUR TRIPS*/
            if((upcoming_class.order_of_go_trips && upcoming_class.order_of_go_trips.length) > 0){
              return <div>Your Trips: {upcoming_class.order_of_go_trips.join(', ')}(<Link to={'/classsignup/viewSetOrder?cgid='+upcoming_class['class_group_id']+'&sid='+current_show}>View</Link>)</div>
            }else{
                return <div><Link to={'/classsignup/viewSetOrder?cgid='+upcoming_class['class_group_id']+'&sid='+current_show}>View</Link></div>
            }
        }else{
            
            if((upcoming_class.your_trips && upcoming_class.your_trips.length) > 0){
                return <div>Your Trips: {upcoming_class.your_trips.join(', ')}(<Link to={'/classsignup/index?cgid='+upcoming_class['class_group_id']+'&sid='+current_show}>Change</Link>)</div>
            }else{
                return <div><Link to={'/classsignup/index?cgid='+upcoming_class['class_group_id']+'&sid='+current_show}>Available Now</Link></div>
            }
        }
    }

    function getUserData(){
      axios.get(user_info_url)
      .then((response) => {
        if(response.data.user && response.data.user != null){
          setUserData(response.data.user)
        }else{
        }
      }, (error) => {
      });
    }

        if(loading) {
          
            return null;
        }
        if(localStorage.getItem("ring_exp_status") === null) {
          setRingExpStatus();
        }

        return(
            <div className="sgl-plugin section-to-print classSignupDetailsCss">
                <h2>Orders of Go/Signups - {show_name} ({display_date})</h2>
                <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br/>
                <div className="tab">
                    { 
                        show_days_list.map((day, index) => {
                            const default_tab = show_date === day.date ? " active" : "";
                            return (
                                // <Tooltip title="Delete">
                                <button key={index} className={["tablinks", "element", default_tab].join(' ')}  onClick={openTab(day.date)} id={day.date}>
                                    {day.day}
                                    {/* <span className="tooltip">I appear on hover!</span> */}
                                </button>
                                // </Tooltip>
                            )
                        })
                    }
                </div>
                <div id="ringWrapper" className='ringWrapper'>
                    {rings.map((ring, index) => (
                        
                        <div key= {index} className="div-responsive">
                            <div  className='class-details, primary-header class-details-header'>
                                <p className="ring-name sgl-nm-ring-name">{ring.ring_name}</p>
                                <div className='ring-arrow sgl-arrow'>
                                    <span className={setArrow(ring.ring_number)} onClick={handleExpandClick(ring.ring_number)}></span>
                                </div>
                            </div>

                            <div id={'detail'+ring.ring_number} className={getExtendedClass(ring.ring_number)}> 
                            <table className="table table-striped table-hover">
                    
                                <tbody>
                                <tr className="sgl-primary-header">
                                    <th style={{min_width: '20px'}}></th>
                                    <th>Class</th>
                                    { (show_est_time || show_planned_time) &&
                                        <th className="center-align" nowrap="nowrap">Est. Start</th>
                                        
                                    }
                                    <th className="center-align">Your Trips</th>
                                    <th className="center-align">Order of Go/Signups</th>
                                </tr>
                                { (ring.upcoming_classes.length > 0)?
                                    ring.upcoming_classes.map((upcoming_class, index) => {
                                    return (
                                        <tr key={index} className='sgl-anchor'>
                                            <td style={{min_width: '20px'}} nowrap="nowrap">{getBullets(upcoming_class)}</td>
                                            {(upcoming_class.schedule_break) ?
                                                <td>{upcoming_class.group_name}</td>
                                              :
                                                <td onClick={(upcoming_class.classes.length == 0)? undefined : openClass(upcoming_class.classes)}>
                                                  {upcoming_class.group_name} ({getClassIds(upcoming_class.classes)} )
                                                </td>
                                            }
                                            { (show_planned_time) &&
                                                <td className="center-align" nowrap="nowrap">{((upcoming_class.start_time_default !== '00:00:00') ? format_time(upcoming_class.start_time_default) : '' )}</td>
                                             || (show_est_time) &&
                                                <td className="center-align" nowrap="nowrap">{((upcoming_class.estimated_start_time !== '00:00:00') ? format_time(upcoming_class.estimated_start_time) : '' )}</td>
                                            }
                                            {(upcoming_class.schedule_break) ?
                                              <td></td>
                                            :
                                              <td className="center-align" nowrap="nowrap">{upcoming_class.trips} of {upcoming_class.total_trips}</td>
                                            }
                                            <td className="center-align" nowrap="nowrap">{getView(upcoming_class)}</td>
                                        </tr>
                                    )
                                    })
                                :
                                    <tr>
                                        <td> </td>
                                        <td>No additional classes are available for sign up in this ring</td>
                                    </tr>
                                }
                                </tbody>
                            </table>
                            </div>
                        </div>
                    ))}
                    
                </div>
                <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
            </div>
        )
    // }
  }
export default ClassSignup